<script setup lang="ts">
import type { NuxtError } from '#app';

defineProps({
  error: {
    type: Object as () => NuxtError,
    required: true,
    default: () => {},
  },
});
</script>

<template>
  <div class="error">
    <div class="error__splash">
      <h1 v-if="error?.statusCode !== 503" class="mb-4 font-40">{{ error?.statusCode }}</h1>
      <p class="font-20">
        <b>{{ error?.statusMessage }}:</b> <span v-html="error?.message"></span>
      </p>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.error {
  background: linear-gradient(135deg, #0079fd 0, #8800f8 100%);
  color: white;
  height: 100vh;

  &__splash {
    position: absolute;
    top: 50%;
    left: 50%;
    text-align: center;
    transform: translate(-50%, -50%);
  }
}
</style>
